import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  makeStyles,
  CircularProgress,
} from "@material-ui/core";
import {
  Print as PrintIcon,
  GetApp as DownloadIcon,
  Close as CloseIcon,
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  dialogPaper: {
    maxWidth: "90vw", // Responsive width
    maxHeight: "90vh", // Ensures dialog is large but doesn't overflow screen
    width: "100%",
  },
  dialogTitle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2),
  },
  closeButton: {
    marginLeft: "auto",
  },
  contentContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "80vh", // Adjusts to available screen space
  },
  fileViewer: {
    width: "100%",
    height: "80vh", // Makes it full height within the dialog
    border: "none",
  },
  loadingContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "80vh", // Match viewer height
  },
  actionButton: {
    margin: theme.spacing(1),
  },
}));

const DriveFileViewerDialog = ({ open, onClose, fileId, onPrint }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(true);

  const handlePrint = () => {
    onPrint();
  };

  const handleDownload = () => {
    if (fileId) {
      const downloadUrl = `https://drive.google.com/uc?export=download&id=${fileId}`;
      window.open(downloadUrl, "_blank");
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="lg"
      fullWidth
      classes={{ paper: classes.dialogPaper }} // Ensures full-size modal
      aria-labelledby="file-viewer-dialog-title"
    >
      <DialogTitle
        id="file-viewer-dialog-title"
        disableTypography
        className={classes.dialogTitle}
      >
        <Typography variant="h6">File Viewer</Typography>
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers className={classes.contentContainer}>
        {loading && (
          <div className={classes.loadingContainer}>
            <CircularProgress />
          </div>
        )}
        {fileId && (
          <iframe
            src={`https://drive.google.com/file/d/${fileId}/preview`}
            className={classes.fileViewer}
            title="File Preview"
            allowFullScreen
            onLoad={() => setLoading(false)}
            style={{ display: loading ? "none" : "block" }}
          />
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<PrintIcon />}
          onClick={handlePrint}
          className={classes.actionButton}
        >
          Print
        </Button>
        <Button
          variant="outlined"
          color="primary"
          startIcon={<DownloadIcon />}
          onClick={handleDownload}
          className={classes.actionButton}
        >
          Download
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DriveFileViewerDialog;